import React from 'react';
import { cn } from '../../lib/cn';

const labelClass = 'mb-2 block text-[10px] font-bold uppercase tracking-[0.16em] text-[var(--ink-3)]';
const fieldClass = 'w-full rounded-[var(--r-sm)] border border-[var(--cream-2)] bg-[var(--cream-1)] px-4 py-[11px] text-sm text-[var(--ink-1)] outline-none transition focus:border-[var(--ai-4)] focus:shadow-[0_0_0_3px_rgba(91,141,239,0.15)]';

export interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  label?: string;
  hint?: string;
  error?: string;
}

export function Textarea({ label, hint, error, className, ...props }: TextareaProps) {
  return (
    <div>
      {label ? <label className={labelClass}>{label}</label> : null}
      <textarea {...props} className={cn(fieldClass, 'min-h-[80px] resize-y leading-normal', error && 'border-[var(--terracotta)]', className)} />
      {hint || error ? <div className={cn('mt-1.5 text-[11.5px]', error ? 'text-[var(--terracotta)]' : 'text-[var(--ink-3)]')}>{error ?? hint}</div> : null}
    </div>
  );
}
